var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 47.1668L70.5 30.5002L40.5 13.8335L10.5 30.5002L40.5 47.1668ZM40.5 47.1668L61.0303 35.761C62.8392 40.3221 63.8333 45.2949 63.8333 50.5C63.8333 52.8377 63.6328 55.1286 63.248 57.3563C54.5477 58.2023 46.6635 61.8356 40.5 67.352C34.3365 61.8356 26.4524 58.2023 17.7521 57.3564C17.3672 55.1285 17.1667 52.8376 17.1667 50.4998C17.1667 45.2948 18.1608 40.322 19.9696 35.761L40.5 47.1668ZM27.1667 67.1667V42.1668L40.5 34.7594",
    stroke: "#345658",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTeacher);
export default __webpack_public_path__ + "static/media/Btn_Teacher.a76f168db8ec91a2c1a101758923e7e4.svg";
export { ForwardRef as ReactComponent };